import React, { useState } from 'react';
import { ShoppingBag, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';

export const AddToCartButton = ({ product, className = '' }) => {
  const { addItem, openCart } = useCart();
  const [added, setAdded] = useState(false);

  const handleAdd = () => {
    addItem(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
    openCart();
  };

  return (
    <Button
      onClick={handleAdd}
      className={`btn-primary-warm rounded-[10px] h-11 px-6 flex items-center gap-2 ${className}`}
      disabled={added}
      data-testid={`add-to-cart-${product.slug}`}
    >
      {added ? (
        <>
          <Check size={18} />
          Agregado
        </>
      ) : (
        <>
          <ShoppingBag size={18} />
          Agregar al carrito
        </>
      )}
    </Button>
  );
};

export default AddToCartButton;
